import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, errorText } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export default function AuthCallback() {
  const { hash } = useLocation();
  const nav = useNavigate();
  const { acceptSession } = useAuth();
  const done = useRef(false);
  const [msg, setMsg] = useState("Signing you in…");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const sid = params.get("session_id");
    const code = params.get("login_code");
    const next = sessionStorage.getItem("bpj_next") || "/account";
    sessionStorage.removeItem("bpj_next");
    const req = sid ? api.post("/auth/google/session", { session_id: sid }) : api.post("/auth/exchange", { code });
    req.then(({ data }) => {
      acceptSession(data);
      toast.success(`Welcome, ${(data?.name || "reader").split(" ")[0]}`);
      nav(next.startsWith("/") ? next : "/account", { replace: true });
    }).catch((e) => {
      setMsg(errorText(e));
      toast.error(errorText(e));
      nav("/account", { replace: true });
    });
  }, [hash, nav, acceptSession]);

  return <div className="min-h-[60vh] grid place-items-center f-serif text-2xl text-[var(--ink)]" data-testid="auth-callback">{msg}</div>;
}
